/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiGovernanceModelSummary {
    getFixupPrototypeFunction() { return AiGovernanceModelSummary.fixupPrototype; }

    static newInstance(model: Partial<AiGovernanceModelSummary>): AiGovernanceModelSummary {
        let obj = Object.assign(new AiGovernanceModelSummary(), model);
        AiGovernanceModelSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiGovernanceModelSummary>): AiGovernanceModelSummary {
        if (!model) return null;
        return AiGovernanceModelSummary.newInstance(<AiGovernanceModelSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiGovernanceModelSummary) {
        if (!obj) return;

        models.AiGovernanceModelSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiGovernanceModelSummary): boolean {
        Object.setPrototypeOf(obj, AiGovernanceModelSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.input_tokens === undefined) {
            this.input_tokens = 0;
        }
        if (this.latency_ms === undefined) {
            this.latency_ms = 0;
        }
        if (this.output_tokens === undefined) {
            this.output_tokens = 0;
        }
        if (this.prompt_count === undefined) {
            this.prompt_count = 0;
        }
        if (this.prompt_input_cost === undefined) {
            this.prompt_input_cost = 0;
        }
        if (this.prompt_output_cost === undefined) {
            this.prompt_output_cost = 0;
        }
    }

    /**
     * Name of the model that handled the invocation
     */
    model_name: string;

    /**
     * Number of input tokens consumed
     */
    input_tokens: number;

    /**
     * End-to-end latency in milliseconds
     */
    latency_ms: number;

    /**
     * Number of output tokens produced
     */
    output_tokens: number;

    /**
     * Number of prompts invoked in the model
     */
    prompt_count: number;

    /**
     * Input-side cost for the invocation
     */
    prompt_input_cost: number;

    /**
     * Output-side cost for the invocation
     */
    prompt_output_cost: number;

}
